import { IResultMessage, ResultMessageType } from "@multiweb/types/contracts/responses";

export interface IResultMessageDTO {
    readonly MsgType: ResultMessageTypeDTO;
    readonly Text: string;
    readonly LocKey: string;
}

export enum ResultMessageTypeDTO {
    error = -1,
    warning = 1,
    information = 0,
    recommendation = 2,
}

export function convertResultMessages(messages: IResultMessageDTO[]): IResultMessage[] {
    return messages ? messages.map(message => convertResultMessage(message)) : [];
}

export function convertResultMessage(message: IResultMessageDTO): IResultMessage {
    return {
        type: convertMessageType(message.MsgType),
        text: message.Text,
        locKey: message.LocKey,
    };
}

export function convertMessageType(type: ResultMessageTypeDTO): ResultMessageType {
    switch (type) {
        case ResultMessageTypeDTO.error:
            return ResultMessageType.error;
        case ResultMessageTypeDTO.information:
            return ResultMessageType.information;
        case ResultMessageTypeDTO.warning:
            return ResultMessageType.warning;
        case ResultMessageTypeDTO.recommendation:
            return ResultMessageType.recommendation;
    }
}
